import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {CALENDAR_FILL__16} from '@homeaway/svg-defs/lib/defs/CALENDAR_FILL__16';
import './style.less';

const StabDatePickerIcon = () => (
    <SVGIcon markup={CALENDAR_FILL__16} className={'stab-date-picker__icon'} />
);

export default StabDatePickerIcon;
